<template>
  <div>
    <div v-if="!communicateShow">
      <Form :model="formItem" :label-width="100" inline label-position="left">
        <FormItem :label="$t('Name')"
          ><!-- 员工姓名 -->
          <Input v-model="formItem.userName" style="width: 200px;" />
        </FormItem>
        <FormItem :label="$t('Employee_Code')" :label-width="120"
          ><!-- 员工号 -->
          <Input v-model="formItem.empCode" style="width: 200px;" />
        </FormItem>
        <FormItem :label="$t('Department')"
          ><!-- 部门 -->
          <Select v-model="formItem.department" clearable style="width: 200px;">
            <Option
              v-for="item in departmentList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('Position')"
          ><!-- 职位 -->
          <!-- <Select v-model="formItem.position" style="width: 200px;">
            <Option v-for="item in positionList" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
          </Select> -->
          <Input v-model="formItem.position" style="width: 200px;" />
        </FormItem>
        <FormItem :label="$t('Year')"
          ><!-- 年度 -->
          <DatePicker
            style="width: 200px;"
            type="year"
            v-model="formItem.year"
          ></DatePicker>
        </FormItem>
        <FormItem :label="$t('Communication_promoter')"
          ><!-- Communication_promoter -->
          <Input v-model="formItem.submitName" style="width: 200px;" />
        </FormItem>
        <Button @click="getData" style="margin-bottom:20px"
          ><!-- 检索 -->{{ $t("Search") }}</Button
        >
        <Button @click="handleReset()" style="margin-bottom:20px"
          ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
        >
      </Form>
      <Table border :loading="loading" :columns="columns" :data="columnsData">
        <template slot-scope="{ row, index }" slot="action">
          <Badge :count="Number(row.beReadFlag)" :offset="[10, 1]">
            <Icon
              type="ios-list-box"
              style="font-size: 30px"
              color="#459846"
              @click="connectClick(row, index), (communicateShow = true)"
            ></Icon>
          </Badge>
        </template>
      </Table>
      <div
        style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:40px"
      >
        <Page :total="this.totalNum" @on-change="pageChange" />
      </div>
      <div style="display: flex;justify-content: flex-end;">
        <Button @click="(findModalShow = true), getUserData()"
          ><!-- 新增 -->{{ $t("Add") }}</Button
        >
        <Button @click="CalculatePerformanceTrends()"
        ><!-- 新增 -->{{ $t("执行")  }}</Button
      >
      </div>
      <Modal
        v-model="findModalShow"
        :title="$t('Add')"
        width="90%"
        @on-ok="ok"
        @on-cancel="cancel"
        ><!-- 新增 -->
        <Form
          :model="modalFormItem"
          :label-width="100"
          inline
          label-position="left"
        >
          <FormItem :label="$t('Name')"
            ><!-- 姓名 -->
            <Input v-model="modalFormItem.userName" style="width: 200px;" />
          </FormItem>
          <FormItem :label="$t('Employee_Code')"
            ><!-- 员工号 -->
            <Input v-model="modalFormItem.empCode" style="width: 200px;" />
          </FormItem>
          <Button @click="getUserData"><!-- 检索 -->{{ $t("Search") }}</Button>
        </Form>
        <Table
          border
          :loading="loading"
          :columns="modalColumns"
          :data="modalColumnsData"
          @on-selection-change="handleSelect"
        >
        </Table>
        <div
          style="margin-top: 10px;display: flex;justify-content: flex-end;margin-bottom:40px"
        >
          <Page :total="this.modalTotalNum" @on-change="modalPageChange" />
        </div>
      </Modal>
    </div>
    <div v-if="communicateShow">
      <div class="addQuestion">
        <Button @click="(questionModalShow = true), (questionIsAdd = true)"
          ><!-- 新建话题 -->{{ $t("Add_Topic") }}</Button
        >
      </div>
      <Collapse v-model="collapseValue" simple>
        <Panel
          hide-arrow
          :name="index + ''"
          v-for="(item, index) in communicateList"
          :key="item.id"
        >
          <div class="panelTit">
            <Avatar
              style="background-color: #006B37"
              icon="ios-person"
              size="large"
            />
            <div style="margin-left:20px;width:90%">
              <div class="panelAuser">
                <span class="name">{{ item.createUserName }}</span
                ><span class="time">{{
                  date.dateVal(item.createTime, "YYYY-MM-DD")
                }}</span>
              </div>
              <div class="questionContent">
                {{ item.common }}
              </div>
            </div>
          </div>
          <div slot="content" class="cs-communicate-children">
            <div
              class="cs-communicate-item"
              v-for="item2 in item.continuedConnectRecordList"
              :key="item2.id"
            >
              <Avatar
                style="background-color: #006B37"
                icon="ios-person"
                size="large"
              />
              <div style="margin-left:20px;width:90%">
                <div class="panelAuser">
                  <span class="name">{{ item2.createUserName }}</span
                  ><span class="time">{{
                    date.dateVal(item.createTime, "YYYY-MM-DD")
                  }}</span>
                </div>
                <div  class="questionContent">
                  {{ item2.common }}
                </div>
              </div>
            </div>
            <div class="cs-communicate-button">
              <Button
                @click="
                  (questionModalShow = true),
                    (questionIsAdd = false),
                    (recordId = item.id)
                "
                ><!-- 回复话题 -->{{ $t("Reply") }}</Button
              >
            </div>
          </div>
        </Panel>
      </Collapse>
      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <Button @click="(communicateShow = false), getData()"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
    <Modal
      v-model="questionModalShow"
      :title="questionIsAdd ? $t('Add_Topic') : $t('Reply')"
      @on-ok="onAddCommunicate"
      ><!-- 新建话题 --><!-- 回复话题 -->
      <Input
        type="textarea"
        :rows="5"
        v-model="question"
        :placeholder="questionIsAdd ? '' : $t('Reply')"
      ></Input>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
export default {
  data() {
    return {
      loading: false,
      date: new DateUtil(),
      collapseValue: [0, 1, 2, 3, 4, 5],
      communicateList: [],
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      question: "",
      nowQuestionIndex: "",
      questionIsAdd: true,
      questionModalShow: false,
      findModalShow: false,
      communicateShow: false,
      formItem: {},
      modalFormItem: {},
      list: [],
      modalTotalNum: 0,
      modalPageInfo: {
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      },
      columnsData: [],

      spinShow: false,
      modalColumnsData: [],
      selsectUserList: [],
      connectId: "",
      recordId: "",
      positionList: [],
      departmentList: [],
      businessUnitList: []
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: this.lang == "zh" ? "userName" : "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnitList &&
                this.businessUnitList
                  .filter(item => params.row.businessUnit == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: "department",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.departmentList &&
                this.departmentList
                  .filter(item => params.row.department == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_English") /* 职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 200
        },
        // ,{
        //   title: this.$t('Line_Manager'),/* 直线上级*/
        //   key: "dirSupName",
        //   align: "center",
        //   minWidth: 120
        // }
        {
          title: this.$t("Communication_promoter") /* Communication_promoter*/,
          key: this.lang == "zh" ? "submitName" : "submitEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Communication") /* 沟通 */,
          slot: "action",
          align: "center",
          minWidth: 80
        }
      ];
    },
    modalColumns() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: this.lang == "zh" ? "userName" : "eName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnitList &&
                this.businessUnitList
                  .filter(item => params.row.businessUnit == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: "department",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.departmentList &&
                this.departmentList
                  .filter(item => params.row.department == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_English") /* 职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Line_Manager") /* 直线上级*/,
          key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
    modalColumnsA() {
      let arr = JSON.parse(JSON.stringify(this.columns));
      arr.pop();
      arr.shift();
      return [...this.modalColumns, ...arr];
    }
  },

  created() {
    // this.modalColumns = [...this.modalColumns, ...arr];
    this.getListData();
    this.getData();
  },
  watch: {
    questionModalShow() {
      this.question = "";
    }
  },
  methods: {
    CalculatePerformanceTrends(){
      axios.post("/AchPeopleBoard/CalculatePerformanceTrends", {}).then(res => {});
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res && res != null) {
          this.positionList = res.positionList;
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
        }
      });
    },
    getData() {
      this.loading = true;
      axios
        .post("/ContinuedConnect/selectConnectConnectList", {
          ...this.formItem,
          ...this.pageInfo
        })
        .then(res => {
          if (res && res != null) {
            this.columnsData = res.data;
            this.totalNum = Number(res.pageInfo.total);
          }
          this.loading = false;
        });
    },
    getUserData() {
      this.loading = true;
      axios
        .post("/ContinuedConnect/selectConnectUserList", {
          ...this.modalFormItem,
          ...this.modalPageInfo
        })
        .then(res => {
          if (res && res != null) {
            this.modalColumnsData = res.data;
            this.modalTotalNum = Number(res.pageInfo.total);
          }
          this.loading = false;
        });
    },
    handleSelect(list) {
      this.selsectUserList = list;
    },
    ok() {
      axios
        .post("/ContinuedConnect/insertConnectList", this.selsectUserList)
        .then(res => {
          if (res && res != null) {
            this.getData();
          }
        });
    },
    cancel() {},
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    modalPageChange(val) {
      this.modalPageInfo.pageNo = val;
      this.getUserData();
    },
    connectClick(row, index) {
      this.connectId = row.id;
      this.spinShow = true;
      axios
        .post("/ContinuedConnect/selectConnectRecordList", {
          connectId: row.id
        })
        .then(res => {
          this.spinShow = false;
          if (res && res != null) {
            this.communicateList = res;
          }
        });
      axios
        .post("/ContinuedConnect/clearBeReadStatus", { connectId: row.id })
        .then(res => {});
    },
    onAddCommunicate() {
      let obj = {
        common: this.question,
        connectId: this.connectId,
        recordId: this.recordId,
        level: this.questionIsAdd ? 1 : 2
      };
      axios.post("/ContinuedConnect/insertConnectRecord", obj).then(res => {
        if (res && res != null) {
          axios
            .post("/ContinuedConnect/selectConnectRecordList", {
              connectId: this.connectId
            })
            .then(res => {
              if (res && res != null) {
                this.communicateList = res;
              }
            });
        }
      });
    },
    handleReset() {
      this.formItem = {};
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    }
  }
};
</script>
<style lang="less" scoped>
.addQuestion {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: flex-end;
}
.panelTit {
  display: flex;
  padding-top: 15px;
  color: #6b6b6b;
}
/deep/.ivu-collapse
  > .ivu-collapse-item.ivu-collapse-item-active
  > .ivu-collapse-header {
  border-bottom: 0 !important;
  color: #ffffff !important;
}
/deep/.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  height: auto;
}
/deep/.ivu-collapse {
  border-top: 0;
}
.panelAuser {
  margin-top: -5px;
  .name {
    font-weight: bold;
    margin: 0 10px 0 0;
    color: #000000;
  }
}
.questionContent {
  width: 90%;
  white-space:pre-line
}
.cs-communicate-item {
  background-color: rgb(244, 244, 244);
  border-radius: 15px;
  width: 100%;
  padding: 20px;
  display: flex;
  margin: 15px 0;
  line-height: 38px;
}
.cs-communicate-title {
  margin-bottom: 10px;
  padding: 5px;
  font-weight: bold;
  border-bottom: 1px solid #b3b4b6;
}

.cs-communicate-content {
  min-height: 60px;
  margin-right: 10px;
  padding: 5px;
  border: 1px solid #dcdee2;
  border-top-width: 2px;
  border-top-color: #b3b4b6;
}
.cs-communicate-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
}
.cs-communicate-button button:first-of-type {
  margin-right: 15px;
}
.cs-communicate-children {
  margin-left: 30px;
}
.cs-communicate-children .cs-communicate-title {
  font-weight: 400;
}
.cs-communicate-children .cs-communicate-content {
  border: 1px solid #dcdee2;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/QAComponents/ContinuousCommunication.vue